import copy from 'copy-to-clipboard';
import styled from '@emotion/styled';
import { ChevronRightIcon, XIcon, FacebookIcon } from '@imus/base-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Content, FieldCardAction } from 'imdui';

const FieldCardActionStyled = styled(FieldCardAction)`
  margin-bottom: 16px;
`;

const ShareActions = styled.div`
  display: grid;
  gap: 8px;
`;

function objectToGetParams(object: {
  [key: string]: string | number | undefined | null;
}) {
  const params = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );

  return params.length > 0 ? `?${params.join('&')}` : '';
}

export const ShareWindowContent = ({ url: providedUrl }: { url?: string }) => {
  const { t } = useTranslation();
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setClicked(false), 1500);
    return () => {
      clearTimeout(timer);
    };
  }, [clicked]);

  const url =
    providedUrl || (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <>
      <FieldCardActionStyled
        primary={true}
        action={
          <Button
            appearance="stroke"
            text={clicked ? t('copied') : t('copy-link')}
            primary={true}
            onClick={() => {
              setClicked(true);
              copy(url);
            }}
          />
        }
      >
        <Content style={{ minWidth: 0, wordBreak: 'break-all' }}>{url}</Content>
      </FieldCardActionStyled>

      <ShareActions>
        <div>
          <FieldCardAction
            onClick={() => {
              window.open(
                `https://www.facebook.com/sharer/sharer.php${objectToGetParams({ u: url })}`
              );
            }}
            icon={<FacebookIcon />}
            action={<ChevronRightIcon />}
          >
            <Content>Facebook</Content>
          </FieldCardAction>
        </div>
        <div>
          <FieldCardAction
            onClick={() => {
              window.open(
                'https://twitter.com/intent/tweet' +
                  objectToGetParams({
                    url,
                  })
              );
            }}
            icon={<XIcon />}
            action={<ChevronRightIcon />}
          >
            <Content>X</Content>
          </FieldCardAction>
        </div>
      </ShareActions>
    </>
  );
};
